import { CloudDownload } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const CloudDownloadIcon = createLucideIcon(CloudDownload);
